import { render, staticRenderFns } from "./ModalWebAwesomeAnnouncement.vue?vue&type=template&id=c6afe8da"
import script from "./ModalWebAwesomeAnnouncement.vue?vue&type=script&lang=js"
export * from "./ModalWebAwesomeAnnouncement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports